export class Patient {
  patientId: number;
  patientName: string;
  homePhone: string;
  cellPhone?: string;
  slot: string;
  appointmentDateTime: string;
  amountDue: number | string;
  currentBalance: number | string;
  thirtyDay: number | string;
  sixtyDay: number | string;
  ninetyDay: number | string;
  treatmentDetails: string;
  provider: string;
  payor: string;
  servicesClosed: boolean | string;
  appointmentStatus: string;
  status?: string;
  paymentStatus?: string;
  dateOfService?: Date | string;
}

export class PatientListReqCommand {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  firstName: string = '';
  lastName: string = '';
  patientId: number = 0;
  amountDue: string = '';
  paymentAge?: number = 0;
  paymentStatus?: string = '';
  appointmentDateTime?: Date = new Date();
  amountOperator?: number = 1;
}

export class TransactionHistoryReqCommand {
  patientId: number;
  practiceId: number;
  pageNumber: number;
  pageSize: number;
  paymentStatus?: number[]; 
  fromTransactionDate?: string;
  toTransactionDate?: string;
  searchTerm: string = '';
}

export class TransactionHistoryResp {
  transactions: TransactionHistory[];
  totalRecords: number;
}

export class PatientListResp {
  patientList: Patient[] = [];
  totalRecords: number = 0;
}

export class PatientBillingSummaryReqCommand {
  patientId: number;
  practiceId: number;
  isDoSView?: boolean;
  searchTerm?: string = '';
  sortBy?: number = 1;
  sortFieldName?: string = '';
  pageNumber?: number = 1;
  pageSize?: number = 15;
  startDate?: any;
  endDate?: any;
  paymentStatus?: number;
}

export class PatientBillingSummaryResp {
  patientSummary: PatientSummary = new PatientSummary();
  billingSummary: BillingSummary[];
  totalBillingSummary: TotalBillingSummary = new TotalBillingSummary();
  totalRecords: number;
  shouldSyncStart: boolean;
}

export class PatientSummary {
  patientId: number;
  salutation: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  homePhone: string;
  cellPhone?: string;
  primaryInsurance: string;
  primaryPolicyNumber: string;
  secondaryInsurance: string;
  secondaryPolicyNumber: string;
  subscriberName: string;
  subscriberID: string;
  notes: string;
  status: string;
  birthDate: string;
  socialSecurity: string;
  genderInfo: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  primRelationship: string;
  defaultPaymentMethod: number;
  lastSynced:Date;
  lastSyncStarted:Date;
}

export class BillingSummary {
  appointmentType: string;
  billedInsPortion: number = 0;
  billedNetDue: number = 0;
  billedPatPortion: number = 0;
  doS: string = new Date().toString();
  dueSince: string;
  fee: number = 0;
  netPaid: number = 0;
  paidInsPortion: number = 0;
  paidPatPortion: number = 0;
  procedureNumber: number = 0;
  serviceCode: string;
  tWriteOffers: number = 0;
  totalBilled: number = 0;
}

export class TotalBillingSummary {
  insuranceOwed: number = 0;
  patientOwed: number = 0;
  prePaymentBalance: number = 0;
  totalOwed: number = 0;
  totalWriteoffs: number = 0;
  totalAdjustments: number = 0;
  unallocatedWriteoffs: number = 0;
  unallocatedAdjustments: number = 0;
  unallocatedPayments: number = 0;
}

export class DoSView {
  id: number;
  dateOfService: string = new Date().toString();
  transactionDate: string = new Date().toString();
  reference: string;
  procedureName: string;
  providerName: string;
  charge: number;
  credit: number;
  insBalance: number;
  netBalance: number;
}

export class FailedPayment {
  id: number;
  invNo: string;
  transactionId: string;
  receiptId: string;
  amount: number;
  paymentDate: string;
  createDate: string;
  paymentMode: string;
  cardType: string;
  failAge: number;
  status: string;
  fixIt: string = 'Fix It';
  link?: string;
  displayMessage: string;
  note?: string;
}

export class Invoice {
  id: number;
  invNo: string;
  transactionId: string;
  receiptId: string;
  amount: number;
  invDate: string;
  paymentMethod: string;
  cardType: string;
  status: string;
}

export class TransactionHistory {
  id: string;
  invNo: string;
  transactionId: string;
  receiptId: string;
  amount: number;
  paymentDate: string;
  createDate: string;
  sentOn?: string;
  paymentMode: string;
  cardType: string;
  status: string;
  void: string;
  refund: string;
  transactionType: number;
  statusValue: string;
  paymentMethod: string;
  transactionTypesName: string;
  billing?: any;
  note?: any;
  writeBackMessageId: string;
  writeBackStatus: number;
  retriedForTransactionId?: number;
  errorMessage?: string;
  emiTransactionType? : number;
  emiTransactionTypeName? : string;
}

export class PatientDropdown {
  patientId: number;
  patientName: string;
}

export class UpdatePatientDefaultPaymentMethodReqCommand {
  patientId: number;
  defaultPaymentMethod: number;
  practiceId: number;
  customerId: number;
}

export class ValidatePayNowPatientRequest {
  practiceId: number;
  patientId?: number;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
}